'use strict';
module.exports = Odigeo.Model.extend({
    action: null,
    cookie: null,
    socialLogin: false,
    mail: null,
    name: null,
    membership: null,
    recaptchaWidgetID: null,
    recaptchaCallbackData: null,
    recaptchaRendered: false,
    errors: {
        'AUTH_000': 'loginerror',
        'STA_009': 'accountblocked',
        'STA_000': 'accountblocked',
        'VAL_000': 'empty',
        'VAL_002': 'invalid',
        'VAL_003': 'invalid',
        'SSO_006': 'requesterror',
        'STO_000': 'requesterror',
        'UNL_007': 'velocityRules',
        'RCP_001': 'requesterror',
        'default': 'requesterror',
    },
    defaults: {
        isActivated: false,
    },

    init: function() {
        if (!Odigeo._.isEmpty(Odigeo.Utils.readCookie('sso_remember_me'))) {
            this.cookie = decodeURIComponent(Odigeo.Utils.readCookie('sso_remember_me'));
            this.mail = this.cookie.split(';')[0];
            this.name = this.cookie.split(';')[1].replace(/[#+]/g, ' ');
            this.membership = this.cookie.split(';')[2] === 'true';
            this.socialLogin = Odigeo._.includes(['facebook', 'google'], this.cookie.split(';')[3]);
        }
    },
});
